import { render, staticRenderFns } from "./TermsAndConditionsCheckbox.vue?vue&type=template&id=201b2b44"
import script from "./TermsAndConditionsCheckbox.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports